import { htmlFromDom } from './dom/htmlFromDom';

export interface TextToHtmlOptions {
  lineStyle?: string | null;
  shouldAddMonospaceStyle?: boolean;
}

export function textToHtml(text: string, options: TextToHtmlOptions = {}): string {
  return htmlFromDom(document => textToDocumentFragment(document, text, options));
}

export function textToDocumentFragment(
  document: Document,
  text: string,
  options: TextToHtmlOptions = {},
): DocumentFragment {
  return linesToDocumentFragment(document, text.split(/(?:\r\n|\r|\n)/), options);
}

export function linesToDocumentFragment(
  document: Document,
  lines: Iterable<string>,
  options: TextToHtmlOptions = {},
): DocumentFragment {
  const fragment = document.createDocumentFragment();
  const { lineStyle } = options;
  const shouldAddMonospaceStyle = Boolean(options.shouldAddMonospaceStyle);

  for (const lineText of lines) {
    const line = document.createElement('div');

    if (lineStyle) {
      line.setAttribute('style', lineStyle);
    }

    if (shouldAddMonospaceStyle) {
      line.style.fontFamily = 'monospace';
    }

    if (lineText.length === 0) {
      const br = document.createElement('br');
      line.appendChild(br);
    } else {
      line.textContent = expandWhitespace(lineText);
    }

    fragment.appendChild(line);
  }

  return fragment;
}

export const NBSP = '\xa0';

export function expandWhitespace(text: string) {
  // Replace any trailing space, and any sequence of two or more spaces.
  // https://developer.mozilla.org/en-US/docs/Web/API/Document_Object_Model/Whitespace_in_the_DOM
  return text.replace(/[ ]$/, NBSP).replace(/[ ]{2,}/g, expandWhitespaceSequence);
}

function expandWhitespaceSequence(text: string) {
  if (text.length < 2) {
    return text;
  }

  return `${NBSP.repeat(text.length - 1)} `;
}
